angular.module('bizmetryApp').controller('ClientsTabController', function(
    $scope, $mdDialog, $mdToast, $timeout,
    ClientService, ConfigurationService, dialogService
) {

    // ========================================
    // INICIALIZACIÓN
    // ========================================

    $scope.clientTypes = [];
    $scope.loadingClients = false;
    $scope.loadingClientTypes = false;
    $scope.filteredClients = [];

    // Estado de paginación y filtros
    $scope.client = {
        totalItems: 0,
        page: 0,
        totalPages: 0,
        pageSize: 10,
        pageSizeOptions: [5, 10, 15, 25, 50, 100],
        searchDebounce: ConfigurationService.getFromCache('frontend.search_debounce_time') || 1000,
        sortOptions: [
            { value: 'name_asc',  label: 'Name (A-Z)' },
            { value: 'name_desc', label: 'Name (Z-A)' },
            { value: 'date_asc',  label: 'Oldest First' },
            { value: 'date_desc', label: 'Newest First' }
        ],
        selectedSort: 'name_asc',
        search: '',
        selectedType: 'ALL'
    };

    // ========================================
    // BULK SELECTION
    // ========================================

    $scope.selectedClientIds = [];

    $scope.isClientSelected = function (id) {
        return $scope.selectedClientIds.indexOf(id) > -1;
    };

    $scope.toggleClientSelection = function (id) {
        var idx = $scope.selectedClientIds.indexOf(id);
        if (idx > -1) {
            $scope.selectedClientIds.splice(idx, 1);
        } else {
            $scope.selectedClientIds.push(id);
        }
    };

    $scope.allClientsSelected = function () {
        return $scope.filteredClients.length > 0 &&
            $scope.selectedClientIds.length === $scope.filteredClients.length;
    };

    $scope.someClientsSelected = function () {
        return $scope.selectedClientIds.length > 0 &&
            $scope.selectedClientIds.length < $scope.filteredClients.length;
    };

    $scope.toggleSelectAllClients = function () {
        if ($scope.allClientsSelected()) {
            $scope.selectedClientIds = [];
        } else {
            $scope.selectedClientIds = $scope.filteredClients.map(function (c) { return c.id; });
        }
    };

    $scope.clearClientSelection = function () {
        $scope.selectedClientIds = [];
    };

    // ========================================
    // BULK DELETE
    // ========================================

    $scope.bulkDeleteClients = function () {
        if (!$scope.selectedClientIds || $scope.selectedClientIds.length === 0) { return; }

        var count = $scope.selectedClientIds.length;

        dialogService.showDecisionDialog(
            'Confirm Bulk Delete',
            'Are you sure you want to delete <b>' + count + ' client' + (count !== 1 ? 's' : '') + '</b>? This action cannot be undone.'
        ).then(function (decision) {
            if (decision !== 'proceed') { return; }

            var idsToDelete = $scope.selectedClientIds.slice();
            $scope.selectedClientIds = [];
            $scope.loadingClients = true;

            ClientService.bulkDeleteClients($scope.profile.id, idsToDelete)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(count + ' client' + (count !== 1 ? 's' : '') + ' deleted successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.loadClientTypes();
                    $scope.loadClients();
                })
                .catch(function (err) {
                    console.error('[ClientsTab] Bulk delete error:', err);
                    dialogService.showErrorDialog(
                        'Bulk Delete Failed',
                        (err.data && err.data.message) ? err.data.message : 'An error occurred during bulk deletion.'
                    );
                    $scope.loadingClients = false;
                });
        });
    };

    // ========================================
    // CARGAR CLIENT TYPES DESDE API
    // ========================================

    $scope.loadClientTypes = function () {
        if (!$scope.profile || !$scope.profile.id) { return; }

        $scope.loadingClientTypes = true;

        ClientService.getClientTypesByProfile($scope.profile.id)
            .then(function (response) {
                $scope.clientTypes = (response && response.data && response.data.client_types) || [];
                console.log('[ClientsTab] Client types loaded:', $scope.clientTypes.length);
            })
            .catch(function (error) {
                if (error && error.status === 204) {
                    $scope.clientTypes = [];
                    return;
                }
                console.error('[ClientsTab] Error loading client types:', error);
                $scope.clientTypes = [];
            })
            .finally(function () {
                $scope.loadingClientTypes = false;
            });
    };

    // ========================================
    // BÚSQUEDA CON DEBOUNCE
    // ========================================

    var searchTimeout;

    $scope.debouncedClientSearch = function () {
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        searchTimeout = $timeout(function () {
            $scope.onClientNavBarChange();
        }, $scope.client.searchDebounce);
    };

    // ========================================
    // PAGINACIÓN
    // ========================================

    $scope.onClientPageDown = function () {
        if ($scope.client.page > 0) {
            $scope.client.page--;
            $scope.loadClients();
        }
    };

    $scope.onClientPageUp = function () {
        if ($scope.client.page < $scope.client.totalPages - 1) {
            $scope.client.page++;
            $scope.loadClients();
        }
    };

    $scope.onClientPageSizeChange = function () {
        $scope.client.page = 0;
        $scope.loadClients();
    };

    // ========================================
    // CARGAR CLIENTES
    // ========================================

    $scope.loadClients = function () {
        $scope.loadingClients = true;
        $scope.filteredClients = [];
        // Wipe selection on reload to avoid stale IDs
        $scope.selectedClientIds = [];

        var params = {
            page:       $scope.client.page,
            size:       $scope.client.pageSize,
            search:     $scope.client.search,
            clientType: $scope.client.selectedType === 'ALL' ? '' : $scope.client.selectedType,
            sort:       $scope.client.selectedSort
        };

        ClientService.listClientsByProfile($scope.profile.id, params)
            .then(function (response) {
                var data = response && response.data;
                $scope.filteredClients    = (data && data.clients)       || [];
                $scope.client.totalPages  = (data && data.totalPages)    || 0;
                $scope.client.totalItems  = (data && data.totalElements) || 0;
                $scope.client.page        = (data && data.page)          || 0;

                if ($scope.client.page >= $scope.client.totalPages && $scope.client.totalPages > 0) {
                    $scope.client.page = $scope.client.totalPages - 1;
                }
            })
            .catch(function (error) {
                console.error('Error loading clients:', error);
                $scope.filteredClients = [];
            })
            .finally(function () {
                $scope.loadingClients = false;
            });
    };

    // ========================================
    // CAMBIO DE FILTROS
    // ========================================

    $scope.onClientNavBarChange = function () {
        $scope.client.page = 0;
        $scope.loadClients();
    };

    $scope.updateClientFilters = function () {
        $scope.onClientNavBarChange();
    };

    // ========================================
    // CREAR CLIENTE
    // ========================================

    $scope.createNewClient = function () {
        $mdDialog.show({
            controller: 'ClientCreateDialogController',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'profile/tabs/clients/create-clients/client-create-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            multiple: true,
            escapeToClose: false,
            locals: {
                clientTypes:  $scope.clientTypes,
                environments: ($scope.profile && $scope.profile.environments) || [],
                profile:      $scope.profile
            }
        }).then(function (newClient) {
            if (newClient) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Client created successfully!')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadClientTypes();
                $scope.onClientNavBarChange();
            }
        }).catch(function (reason) {
            if (reason === 'cancel') { return; }
            dialogService.showErrorDialog('Error', 'An error occurred while creating the client.');
        });
    };

    // ========================================
    // EDITAR CLIENTE
    // ========================================

    $scope.openEditClientDialog = function (client) {
        $mdDialog.show({
            controller: 'EditClientDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/clients/edit-clients/client-edit-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                client:       client,
                profile:      $scope.profile,
                clientTypes:  $scope.clientTypes,
                environments: ($scope.profile && $scope.profile.environments) || []
            }
        }).then(function (updated) {
            if (updated) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Client updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadClients();
            }
        });
    };

    // ========================================
    // TOGGLE ENABLE/DISABLE
    // ========================================

    $scope.onToggleClientEnabled = function (client) {
        var previousState = client.enabled;

        ClientService.patchClient(client.profileId, client.id, { enabled: client.enabled })
            .then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Client status updated')
                        .position('top right')
                        .hideDelay(2000)
                );
            })
            .catch(function (error) {
                console.error('Error updating client status:', error);
                client.enabled = previousState;
                dialogService.showErrorDialog(
                    'Error',
                    'Failed to update client status. ' + ((error.data && error.data.message) || 'Unknown error')
                );
            });
    };

    // ========================================
    // ELIMINAR CLIENTE (doble clic con confirmación)
    // ========================================

    $scope.confirmDeleteMap = {};
    $scope.deleteTimers = {};
    var CONFIRM_TIMEOUT_MS = 3000;

    $scope.deleteClient = function (client) {
        if (!$scope.confirmDeleteMap[client.id]) {
            $scope.confirmDeleteMap[client.id] = true;

            if ($scope.deleteTimers[client.id]) { $timeout.cancel($scope.deleteTimers[client.id]); }

            $scope.deleteTimers[client.id] = $timeout(function () {
                $scope.confirmDeleteMap[client.id] = false;
                delete $scope.deleteTimers[client.id];
            }, CONFIRM_TIMEOUT_MS);

        } else {
            dialogService.showDecisionDialog(
                'Confirm Delete',
                'Are you sure you want to delete client <b>' + client.name + '</b>?'
            ).then(function (decision) {
                if (decision === 'proceed') {
                    ClientService.deleteClient(client.profileId, client.id)
                        .then(function () {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Client deleted successfully')
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                            // Remove from selection if present
                            var idx = $scope.selectedClientIds.indexOf(client.id);
                            if (idx > -1) { $scope.selectedClientIds.splice(idx, 1); }

                            $scope.loadClientTypes();
                            $scope.loadClients();
                        })
                        .catch(function (err) {
                            dialogService.showErrorDialog(
                                'Error Deleting Client',
                                (err.data && err.data.message) || 'Unknown error'
                            );
                        });
                }

                $scope.confirmDeleteMap[client.id] = false;
                if ($scope.deleteTimers[client.id]) {
                    $timeout.cancel($scope.deleteTimers[client.id]);
                    delete $scope.deleteTimers[client.id];
                }
            });
        }
    };

    // ========================================
    // CLEANUP
    // ========================================

    $scope.$on('$destroy', function () {
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        Object.keys($scope.deleteTimers || {}).forEach(function (k) {
            $timeout.cancel($scope.deleteTimers[k]);
        });
    });

    // ========================================
    // AUTO-LOAD al entrar al tab
    // ========================================

    function safeInitialLoad() {
        if (!$scope.profile || !$scope.profile.id) { return; }

        if (!$scope._clientsLoadedOnce) {
            $scope._clientsLoadedOnce = true;
            $scope.loadClientTypes();
            $scope.loadClients();
        }
    }

    $timeout(function () { safeInitialLoad(); }, 0);

    $scope.$on('clients:tab-selected', function () {
        console.log('[Clients] tab selected → loading');
        if (!$scope._clientsLoadedOnce) {
            safeInitialLoad();
        } else {
            $scope.loadClients();
        }
    });

    $scope.$watch('profile.id', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            $scope._clientsLoadedOnce = false;
            safeInitialLoad();
        }
    });

});